import { Box, Grid, Text, VStack } from '@postenbring/hedwig-react'
import { PostalInputs } from './form/inputs/PostalInputs'
import { ServiceInput } from './form/inputs/ServiceInput'
import { ResultDisplay } from './resultFeedback/ResultDisplay'
import { CalculateButton } from './form/CalculateButton'

export const CalculatorForm = ({ labels, priceEngineProxyUrl }) => (
    <>
    <Grid span={{ initial: 12, large: 7 }} gapY='48-64'>
        <VStack gap="48-64" asChild>
            <Box asChild>
                <form>
                    <VStack gap="20-24">
                        <Text as="h2" variant="h2">{labels.service}</Text>
                        <ServiceInput labels={labels} />
                    </VStack>
                    <VStack gap="20-24">
                        <PostalInputs labels={labels} />
                    </VStack>
                    <div>
                        <CalculateButton
                            labels={labels} priceEngineProxyUrl={priceEngineProxyUrl}
                        />
                    </div>
                </form>
            </Box>
        </VStack>
        <ResultDisplay labels={labels} />
    </Grid>
    </>
)
